/**
 * reated by ShangXiaoyang on 2017/9/13
 */
import imApi from '../../api/imApi'
import * as io from 'socket.io-client'
import * as Constants from '../../common/Constants'
import {Socket} from 'socket.io-client'
import {Message,MessageBox} from 'element-ui'
import axios from '@/utils/request.js'
import lrz from "lrz"
import * as Urls from '../../../src/components/url'

const websocktUrl = process.env.API_WEBSOCKETURL

const imageRex = /^image\/(jpeg|jpg|png|gif|bmp)$/
const videoRex = /^video\/.*$/
const superUrlRegExp = /(http|https|ftp)?(?::\/\/)?(?:\w+)(?=\.)(?:[\w\.]+)(?:[\w&?+=%\-\/\.]+)?/g

const state = {
    entranceList: [], // 访客接口列表
    entranceId:null, //
    currentPosition: null, // 当前排队位置
    timer: {}, // 获取当前排队位置的计时器
    messageList: [], // 对话内容列表
    socket: {}, // 和后端简历的websocket对象
    autoReplyConfig: {}, // 自动消息
    sessionNoReplyTimer:{},//会话超时倒计时

    visitorNoReplyTimer: {}, // 访客未回复倒计时

    userNoReplyTimer: {}, //客服未回复倒计时
    newSession: false, // 设置是否是新会话
    userNickNamePool: {}, // 客服名称和Id的前端缓存 数据结构: {1001: '小静静', 1002: '小亮亮'}
    uniqueMsgMap: {} , // 去重容器
    satisfyMode: null,// 满意度版本(1.基础版 2.问卷版)
    showSatisfySettingFlag: false, // 显示满意度评价
    currentUserId:null, // 当前客服昵称
    currentUserNickName: '', // 当前客服昵称
    infor:[],
    endis:true,

}
const processLinkMessage = function (text, sendFrom) { // 处理HTMl
  if (sendFrom == sessionStorage.getItem("md5")) return text // 如果sendFrom等于sessionStorage.md5则说明是玩家用户则不用转换http为a标签
  let httpRegExp = /^(http:\/\/|https:\/\/)/
  text = text.replace(superUrlRegExp, function($url){
    let matchText = $url.match(httpRegExp)
    console.log('发现url:'+ $url +' 是否具有http开头的匹配结果: ' + matchText)
    if (matchText === null) {
      return "<a href='http://" + $url + "' target='_blank'>" + $url + "</a>"
    } else {
      return "<a href='" + $url + "' target='_blank'>" + $url + "</a>"
    }
  })
  return text
}
// file => url
function getObjectURL (file) {
  let url = null ;
  if (window.createObjectURL!=undefined) { // basic
    url = window.createObjectURL(file) ;
  }else if (window.webkitURL!=undefined) { // webkit or chrome
    url = window.webkitURL.createObjectURL(file) ;
  }else if (window.URL!=undefined) { // mozilla(firefox)
    url = window.URL.createObjectURL(file) ;
  }
  return url ;
}
let setVideoCoverLoading = false
// 获取视频封面
function getVideoCover (file, videoUrl, time, callback) {
  // 防止生成重复
  if (setVideoCoverLoading) return false;
  const video = document.createElement('video');
  const canvas = document.createElement('canvas');
  video.src = videoUrl;
  video.style = 'display:none';
  canvas.style = 'display:none';
  document.body.appendChild(video);
  document.body.appendChild(canvas);
  const timer = setTimeout(() => {
    // const video = this.$refs.submissionVideo; // 获取视频 dom
    // const canvas = this.$refs.submissionCanvas; // 获取canvas dom
    const context = canvas.getContext('2d');
    if (!video.readyState) {
      console.error('视频尚未加载完成，无法捕获封面');
      return;
    }
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    video.currentTime = time; // 获取指定时间点的封面
    setVideoCoverLoading = true;
    // 监听视频播放时间，获取封面
    video.addEventListener(
      'seeked',
      () => {
        context.drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
        const coverImageDataUrl = canvas.toDataURL('image/png');
        let blob = dataURLtoBlob(coverImageDataUrl);
        let newName = file.name;
        let newFile = blobToFile(blob, newName);
        // 调用后端上传接口
        // upload(newFile, 0, newName, url => {
        //   this.submitVideoFrom.cover_url = url;
        // });
        callback(getObjectURL(newFile))
        const times = setTimeout(() => {
          video.remove();
          canvas.remove();
          setVideoCoverLoading = false;
          clearTimeout(times);
        }, 300);
        // 将base64转换为blob
        function dataURLtoBlob(dataurl) {
          let arr = dataurl.split(',');
          let mime = arr[0].match(/:(.*?);/)[1];
          let bstr = window.atob(arr[1]);
          let n = bstr.length;
          let u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          return new Blob([u8arr], { type: mime });
        }
        // 将blob转换为file
        function blobToFile(theBlob, fileName) {
          theBlob.lastModifiedDate = new Date();
          theBlob.name = fileName;
          return theBlob;
        }
      },
      { once: true },
    );
    clearTimeout(timer);
  }, 50);
}
const getters = {
    currentPosition11 (state) {
        return state.currentPosition
    },
    messageList (state) {
        return state.messageList
    },
    satisfyMode (state) {
        return state.satisfyMode
    },
    showSatisfySettingFlag (state) {
        return state.showSatisfySettingFlag
    },
    getEntranceList (state) {
        return state.entranceList
    },
    getEntranceId (state) {
        return state.entranceId
    },
     inforchange (state) {
      return state.infor
    },
    endclass(state){
        return state.endis;
    },
    getsocket(state){
        return state.socket;
    }
}
const actions = {
    createSocket({dispatch, commit, state}, obj) { // 建立socket连接
        state.uniqueMsgMap = {} // 去重容器清空
        if (state.socket instanceof Socket) { // 如果已经存在了就断开原来的链接
            state.socket.disconnect();
            state.socket='';
            console.log("存在socket连接,断开现有连接");
            // 断开
            // return;
        }
        var locdat='';
        if(sessionStorage.getItem("locdatpc")){
          locdat=sessionStorage.getItem("locdatpc");
        }else{
          locdat=new Date();
          locdat=locdat.getTime();
          sessionStorage.setItem("locdatpc",locdat)

        }
        state.socket = io.connect(websocktUrl + obj.visitorMd5Code+"&uuid="+locdat,{"multiplex":false},{forceNew: true},{reconnectionDelay:100},{reconnection:true},{reconnectionAttempts:50},{autoConnect:true})

        socketgo()
        // var timew=new Date().getTime();

        // sessionStorage.setItem("socketconnecttime", timew);
        var a=1;
        //测试 链接时间
        var timelong=setInterval(function(){
            if(a<=5){
              if(state.socket.connected){
                clearInterval(timelong);
                console.log('-------------------检测可以建立链接-------------------')
                channelok();
              }
              a++;
            }else{
              console.log('链接不通');
              state.socket.disconnect();
              state.socket = io.connect(websocktUrl + obj.visitorMd5Code+"&uuid="+locdat,{transports: ['polling']},{forceNew: true},{reconnectionDelay:100},{reconnection:true},{reconnectionAttempts:50},{autoConnect:true});
              socketgo();
              console.log('改为轮询模式')
              clearInterval(timelong)
            }

        },1000)

        function channelok(){
          console.log('------------------检测通道----------------');
          //控制次数
          var ctimes=1;
          //通道ok
          var channelis=false;
          state.socket.emit("ping_",0);
          console.log('第一次发送ping包')



          var goping=setInterval(function(){
            ctimes=ctimes+1;
            if(ctimes<=3){
              state.socket.emit("ping_",0);
              console.log('第'+ctimes+'次发送ping包')
            }else{
              console.log('通道不通');
              state.socket.disconnect();
              state.socket = io.connect(websocktUrl + obj.visitorMd5Code+"&uuid="+locdat,{transports: ['polling']},{forceNew: true},{reconnectionDelay:100},{reconnection:true},{reconnectionAttempts:50},{autoConnect:true});
              socketgo();
              console.log('改为轮询模式')
              clearInterval(goping)
            }

          },2000)

              state.socket.on("pong_",function(data){
                if(data==1){
                  channelis=true;
                  clearInterval(goping)
                  console.log('------------------通道ok的----------------');
                }
              });
        }

        // //测试 链接时间
        // if(sessionStorage.getItem("timelong")){
        //   console.log("清除之前的timelong定时器")
        //   clearInterval(sessionStorage.getItem("timelong"));
        // }
        // var timelong=setInterval(function(){
        //   if(state.socket instanceof Socket){
        //       console.log("ok链接没有断开ok")
        //   }else{
        //     var nowtime=new Date().getTime();
        //     var contime = sessionStorage.getItem("socketconnecttime")
        //     if(nowtime-contime >= 300000){
        //      Message({
        //               message: '连接异常，请检查您的网络设置!',
        //               type: 'error'
        //             })
        //     }
        //   }
        // },300000)
        //  sessionStorage.setItem("timelong",timelong);
        //轮询socket链接状态检测

        // if(sessionStorage.getItem("sockettimer")){
        //   console.log("清除之前的sockettimer定时器")
        //   clearInterval(sessionStorage.getItem("sockettimer"));
        // }
        // var sockettimer=setInterval(function(){
        //     axios.get(Urls.baseurl +'/api/visitor/im/connection/status?visitorMd5Code='+obj.visitorMd5Code).then(function (response) {
        //       console.log("检测是否断开连接")
        //       if(response.data.code === 0){
        //         console.log("检测到断开连接");
        //         var timew=new Date().getTime();
        //         //sessionStorage.setItem("socketconnecttime", timew);
        //         //state.socket = io.connect(websocktUrl + obj.visitorMd5Code,{"multiplex":false},{forceNew: true},{reconnectionDelay:100},{reconnection:true},{reconnectionAttempts:50},{autoConnect:true})
        //         location.reload();
        //         console.log("http重新连接")
        //       }else{
        //         console.log("检测没有断开连接")
        //       }

        //     })
        // },60000);
        //sessionStorage.setItem("sockettimer",sockettimer);
        //检测socket的链接状态
        // state.socket.on('disconnect', function (reason) {
        //     console.log('------------------   检测到断开了socket原因为'+reason);
        //     var timew=new Date().getTime();
        //     sessionStorage.setItem("socketconnecttime", timew);


        // })

        //state.socket = io.connect(websocktUrl + obj.visitorMd5Code,{"multiplex":false},{forceNew: true},{reconnectionDelay:100},{reconnection:true},{reconnectionAttempts:50},{autoConnect:true})
        state.socket.on('connect',(data) => {
            console.info('------------------   连接后socket.cookie:' + state.socket.cookie)
            console.info('------------------ data:' + data);
            let path = obj.path


        });
        function socketgo(){
        state.socket.on(obj.visitorMd5Code, function (data) { // 获取推送来的数据
            console.log('socket io chatEvent')
            console.log(data,"socket推送消息")

            if(data) {

                if(data=='T'){
                    console.log(Message)
                    MessageBox.alert('已在其他设备登录，点击确认重新登录', '提示', {
                      confirmButtonText: '确定',
                      callback: action => {
                            location.reload();
                      }
                    })
                }else if(data.imMsgHeader.applicationType){
                let imMsgHeader = data.imMsgHeader;
                let head = imMsgHeader.head? state.imHttp + imMsgHeader.head:'/pc/static/assets/service_pic@2x.png';
                var restime =  data.imMsgProperty.createdTime;
                // 确认消息
                var confirmData = {
                    sessionId: imMsgHeader.sessionId,
                    timeStamp: Date.parse(new Date()),
                    msgId:imMsgHeader.msgId,
                    userId: obj.visitorMd5Code,
                    head:head
                }
                state.socket.emit('confirmEvent', confirmData);
                // 检验是否重复
                let hasContain = state.uniqueMsgMap[imMsgHeader.sessionId+'_'+imMsgHeader.msgId]
                if(hasContain && imMsgHeader.applicationType[1] != 'IM_MESSAGE_REVOKE') {
                    console.error('已经包含了会话:' + imMsgHeader.sessionId + '中的消息:' + imMsgHeader.msgId)
                    return
                }
                if (imMsgHeader&& imMsgHeader.applicationType[0] === 'imQueueAppType'&& imMsgHeader.applicationType[1] === 'QUEUE_NOTIFY' /*排队成功通知*/ ) {
                    commit({
                        type: 'setImStatus',
                        status: 'chatting'
                    })
                    state.newSession = true
                    sessionStorage.setItem('newSession',true)
                    obj.router.replace({path: '/imSession', query: {v: obj.visitorMd5Code}})

                    localStorage.removeItem('visitTime')
                    localStorage.removeItem('userTime')
                    localStorage.removeItem('sessionTime')


                    console.log('设置本会话为新的session');
                    clearInterval(state.timer)
                }
                else if (imMsgHeader&& imMsgHeader.applicationType[0] === 'imChatAppType'&& imMsgHeader.applicationType[1] === 'IM_CHAT' ) {
                    // 聊天消息
                    let imMsgBody = data.imMsgBody
                    if (imMsgBody && imMsgBody.content && imMsgBody.content.length > 0) {
                        for (let item of imMsgBody.content) {
                          console.log("=====打印推送的聊天消息start======")
                          console.log(item.msgContent.content)
                          console.log("=====打印推送的聊天消息end======")
                        let sessionId = data.imMsgHeader.sessionId;
                        let msgId = data.imMsgHeader.msgId;
                        state.uniqueMsgMap[sessionId+'_'+msgId] = sessionId+'_'+msgId
                        //console.log(item,"推送")

                        commit('addMessageContentToMessageList', {
                            type: item.msgType,
                            data: item.msgType === 'TEXT' ? item.msgContent.content : item.msgContent.url,
                            seq: imMsgHeader.seqOrigin,
                            sessionId: imMsgHeader.sessionId,
                            msgId: imMsgHeader.msgId,
                            sendFrom: imMsgHeader.fromId,
                            head:head,
                            userNickName: state.userNickNamePool[imMsgHeader.fromId],
                            time:restime
                        })
                        }

                      state.uniqueMsgMap[imMsgHeader.sessionId+'_'+imMsgHeader.msgId] = true;
                      clearTimeout(state.userNoReplyTimerOut)
                      clearInterval(state.userNoReplyTimer)
                      clearInterval(state.userFun)

                      localStorage.removeItem('sessionTime')
                      localStorage.setItem('session',state.autoReplyConfig.sessionTimeout)
                      localStorage.setItem('visit',state.autoReplyConfig.visitorTimeout)

                      if(window.location.href.indexOf("/imSession") != -1){
                        localStorage.removeItem('sessionTime')
                        dispatch('resetSessionNoReplyTimer', obj.visitorMd5Code)

                        localStorage.removeItem('visitTime')
                        dispatch('resetVisitorNoReplyTimer', obj.visitorMd5Code)
                      }

                        var imMsg=data;
                        var obj1={};
                        obj1.id= imMsg.imMsgHeader.sessionId
                        obj1.time = imMsg.imMsgProperty.createdTime ? imMsg.imMsgProperty.createdTime : new Date().getTime();
                        obj1.time =timechange(obj1.time);
                        function timechange(timestamp){
                            var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                            var Y = date.getFullYear() + '-';
                            var  M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                            var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ''
                              return Y+M+D;
                          }
                        // obj.time = this.timechange(obj.time)
                        obj1.name = imMsg.imMsgHeader.fromName ? imMsg.imMsgHeader.fromName : '访客'

                        let imMsgType = imMsg.imMsgBody.content[0].msgType;
                        //console.log(imMsg,'jjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjjj')
                        switch (imMsgType) {
                            case 'TEXT':
                                obj1.content  = imMsg.imMsgBody.content[0].msgContent.content+" ";
                                break;
                            case 'EVENT':
                                obj1.content  = imMsg.imMsgBody.content[0].msgContent.content+" ";
                                break;
                            case 'IMAGE':
                                obj1.content  = "你收到一张图片。"
                                break;
                            default:

                        }
                        dispatch('infortx',obj1);

                    }
                }else if(imMsgHeader&& imMsgHeader.applicationType[0] === 'imSessionAppType'&& (imMsgHeader.applicationType[1] === 'SESSION_TERMINATE' || imMsgHeader.applicationType[1] === 'SESSION_TERMINATE_TIMEOUT') ){
                    console.log("收到关闭会话通知");
                    console.log(data.imMsgBody);
                    console.log('发送关闭消息的客服Id: ' + imMsgHeader.fromId)
                    console.log('发送关闭消息的客服名称: ' + state.userNickNamePool[imMsgHeader.fromId])
                    console.log('发送关闭会话消息: ' + state.autoReplyConfig.finishedMsg)
                    console.log('清空 state.userNoReplyTimer: ' + state.userNoReplyTimer)
                    console.log('清空 state.visitorNoReplyTimer: ' + state.visitorNoReplyTimer)

                    state.endis=false;
                    sessionStorage.setItem("inviteis", false);
                    commit({
                        type: 'setImStatus',
                        status: 'ended'
                    })


                    let sessionId = data.imMsgHeader.sessionId;
                    let msgId = data.imMsgHeader.msgId;
                    state.uniqueMsgMap[sessionId+'_'+msgId] = sessionId+'_'+msgId

                    clearInterval(state.userNoReplyTimer)
                    clearTimeout(state.userNoReplyTimerOut)
                    clearInterval(state.userFun)
                  localStorage.removeItem('userTime')

                    clearInterval(state.visitorNoReplyTimer)
                    clearTimeout(state.visitorNoReplyTimerOut)
                    clearInterval(state.visitorFun)
                  localStorage.removeItem('visitTime')

                  localStorage.removeItem('sessionTime')
                    clearInterval(state.sessionNoReplyTimer)

                    commit('sendFinishedMsg', obj.visitorMd5Code);
                    if(imMsgHeader.applicationType[1] === 'SESSION_TERMINATE_TIMEOUT'){
                        //console.log('自动结束开始发各种东西')
                        //commit('sendFinishedMsg', obj.visitorMd5Code);
                        commit("setShowSatisfySettingFlag", true);
                        dispatch("getSatisfySettting", {visitorMd5Code:obj.visitorMd5Code});
                        clearInterval(state.userNoReplyTimer)
                        clearInterval(state.visitorNoReplyTimer)
                        clearInterval(state.sessionNoReplyTimer)
                      }
                }
                else if (imMsgHeader&& imMsgHeader.applicationType[0] === 'imChatAppType'&& imMsgHeader.applicationType[1] === 'EVALUATE_NOTIFY'/*评价通知*/) {
                    console.log('收到评价通知: ');
                    //console.log(data.imMsgBody);
                    dispatch("getSatisfySettting", {visitorMd5Code: obj.visitorMd5Code});
                    commit("setShowSatisfySettingFlag", true);
                    // imApi.confirmEvent(imMsgHeader.msgId, obj.visitorMd5Code, function (body) {
                    //     console.log('确认事件的返回值:'+body.code)
                    // })

                  clearTimeout(state.userNoReplyTimerOut)
                  clearInterval(state.userNoReplyTimer)
                  clearInterval(state.userFun)

                  localStorage.removeItem('sessionTime')
                  localStorage.setItem('session',state.autoReplyConfig.sessionTimeout)
                  localStorage.setItem('visit',state.autoReplyConfig.visitorTimeout)

                  if(window.location.href.indexOf("/imSession") != -1){
                    localStorage.removeItem('sessionTime')
                    dispatch('resetSessionNoReplyTimer', obj.visitorMd5Code)

                    localStorage.removeItem('visitTime')
                    dispatch('resetVisitorNoReplyTimer', obj.visitorMd5Code)
                  }


                }

                 else if (imMsgHeader && imMsgHeader.applicationType[0] === 'imChatAppType' && imMsgHeader.applicationType[1] === 'WORKORDER_NOTIFY'/*工单推送通知(显示工单)*/) {
                    console.log('收到工单推送通知: ')
                    console.log(data.imMsgBody);
                    if (data.imMsgBody && data.imMsgBody.content) {
                        let msgContent = data.imMsgBody.content[0].msgContent
                        console.log(msgContent,"msgContent")
                        console.log('收到工单推送的工单Id: ' + msgContent.id)
                        let sessionId = imMsgHeader.sessionId
                        let msgId = imMsgHeader.msgId;
                        state.uniqueMsgMap[sessionId+'_'+msgId] = sessionId+'_'+msgId
                        commit('sendWorkOrderMessage', {workOrderId: msgContent.id, msgId: imMsgHeader.msgId,head:head,time:restime})


                        clearTimeout(state.userNoReplyTimerOut)
                        clearInterval(state.userNoReplyTimer)
                        clearInterval(state.userFun)

                      localStorage.removeItem('sessionTime')
                      localStorage.setItem('session',state.autoReplyConfig.sessionTimeout)
                      localStorage.setItem('visit',state.autoReplyConfig.visitorTimeout)

                        if(window.location.href.indexOf("/imSession") != -1){
                          localStorage.removeItem('sessionTime')
                          dispatch('resetSessionNoReplyTimer', obj.visitorMd5Code)

                          localStorage.removeItem('visitTime')
                          dispatch('resetVisitorNoReplyTimer', obj.visitorMd5Code)
                        }

                    }
                    else {
                        console.log('无法获取工单ID')
                    }
                    console.error('注意收到工单推送的时候是不要确认收到的。要提交之后才算是确认收到。')
                }

                else if (imMsgHeader && imMsgHeader.applicationType[0] === 'imChatAppType' && imMsgHeader.applicationType[1] === 'SERVICE_NOTIFY'/*会话转接or介入*/) {
                    console.log(data.imMsgBody,"会话转接or介入");

                    let msgContent = data.imMsgBody.content[0].msgContent.content
                    let imMsgHeader = data.imMsgHeader
                    let imMsgBody = data.imMsgBody
                    let sessionId = imMsgHeader.sessionId
                    let msgId = imMsgHeader.msgId;
                    state.uniqueMsgMap[sessionId+'_'+msgId] = sessionId+'_'+msgId
                    state.head = head
                    state.currentUserId = imMsgBody.content[0].msgContent.userId
                    state.currentUserNickName = imMsgBody.content[0].msgContent.userNickName
                    state.userNickNamePool[imMsgBody.content[0].msgContent.userId] = imMsgBody.content[0].msgContent.userNickName
                    commit('addMessageContentToMessageList',{
                        data:msgContent,
                        // type:imMsgBody.content[0].msgType,
                        type:"TEXT",
                        seq: imMsgHeader.seqOrigin,
                        sessionId: imMsgHeader.sessionId,
                        head:head,
                        //userNickName: data.imMsgBody.content[0].msgContent.userNickName,
                        // sendFrom: Number(imMsgBody.content[0].msgContent.userNickName),
                        // userNickName: state.userNickNamePool[Number(imMsgBody.content[0].msgContent.userId)],
                        sendFrom: imMsgHeader.fromId,
                        userNickName: state.userNickNamePool[imMsgBody.content[0].msgContent.userId],
                        time:restime
                    })

                    clearTimeout(state.userNoReplyTimerOut)
                    clearInterval(state.userNoReplyTimer)
                    clearInterval(state.userFun)

                  localStorage.removeItem('sessionTime')
                  localStorage.setItem('session',state.autoReplyConfig.sessionTimeout)
                  localStorage.setItem('visit',state.autoReplyConfig.visitorTimeout)

                    if(window.location.href.indexOf("/imSession") != -1){
                      localStorage.removeItem('sessionTime')
                      dispatch('resetSessionNoReplyTimer', obj.visitorMd5Code)

                      localStorage.removeItem('visitTime')
                      dispatch('resetVisitorNoReplyTimer', obj.visitorMd5Code)
                    }



                }else if (imMsgHeader && imMsgHeader.applicationType[0] === 'imChatAppType' && imMsgHeader.applicationType[1] === 'IM_MESSAGE_REVOKE'/*消息撤回*/) {
                  // dosomething
                  const msgId = imMsgHeader.msgId
                  const createdTime = restime
                  commit('revokeMessageList', {msgId, createdTime})
                }


                }
            }
        })
       }
    },
    infortx({commit, state},obj1){
        if(window.location.href.indexOf ("/#/imSession")==-1){
            var audio=document.getElementById("audioPlay");
            audio.play();

            var title1 = document.getElementsByTagName('title')[0];
            title1.innerHTML ='您有新消息:'+obj1.content;
            if(sessionStorage.getItem("addtime")){
                clearInterval(sessionStorage.getItem("addtime"))
            }
            var timer = setInterval(function(){

               var title = title1.innerHTML;
               var fristchar = title.charAt(0); //在从中取第一个字符；(charAt)
               var rightstr = title.substring(1, title.length); //结束位置必须是title.length;
               title1.innerHTML = rightstr + fristchar;
            }, 400);
            sessionStorage.setItem("addtime",timer);
            state.infor.push(obj1);
            setTimeout(function(){
                var nowindex=0;
                state.infor.forEach( function(element, index) {
                  if(element.id==obj1.id){
                    nowindex=index;
                  }
                });
                state.infor.splice(nowindex,1)
            },3000)
        }
    },
    entrance ({commit, state}, obj) { // 获取入口
        let visitorMd5Code = obj.visitorMd5Code
        imApi.entrance(visitorMd5Code, (res) => {
            console.log(res,"获取入口")
            if(res.data.mode === 1){
              obj.router.replace({path: '/imLineUp', query: {v: visitorMd5Code,errType: "costomerErr"}})
            }else if(res.data.mode===2) {
                console.log(obj.router)
                if(obj.inviteis){
                    console.log('主动邀请')
                }else{
                    obj.router.replace({path: '/imDirectory', query: {v: visitorMd5Code,errType: "costomerErr"}})
                }

                commit("setEntranceList", res.data.entranceList )
            }
        })
    },
    enterQueue ({commit,state}, obj) { // 排队
        let entranceId = obj.entranceId
        let visitorMd5Code = obj.visitorMd5Code
        let vm = obj.vm
        clearInterval(state.timer);
        imApi.queryEnterQueue(visitorMd5Code, entranceId, (res)=>{
          console.log(res.code);
          if(res.code === 1){
            obj.router.replace({path: '/imLineUp', query: {v: visitorMd5Code,errType: "costomerErr"}})
          }else if(res.code === 2028){
            obj.router.replace({path: '/serviceError', query: {v: visitorMd5Code,errType: "costomerErr"}})
          }
        })
    },
    startCurrentPositionTimer ({commit, state}, obj) { // 获取当前排队位置
        let visitorMd5Code = obj.visitorMd5Code;
        var entranceId = obj.entranceId;
        console.log(entranceId,"entranceId-im")
        let router = obj.router;
        let objData = {
            visitorMd5Code:visitorMd5Code,
            entranceId: entranceId? entranceId : ""
        }
        clearInterval(state.timer)
        imApi.getPositionAndSessionStatus (objData,(res) => {
            if(res.code ===1){
                var data = res.data
                if (data.position === -1){
                     //data.position === null;
                    //  console.log(state.timer)
                    clearInterval(state.timer)
                    if (data.sessionStatus === 'chatting') {
                      //   console.log('是这跳的吗')
                      //   state.newSession = true
                      // sessionStorage.setItem('newSession',true)
                        router.replace({path: '/imSession', query: {v: visitorMd5Code}})
                    }
                }
                commit('setCurrentPosition', data.position);

            }else if (res.code === 4208) {
                console.error('无法获取到IM会话，或者会话已经过期');
                commit('setCurrentPosition', null); // 从-1切换过来的一个过渡。设置为null
                return
            }
        });
        state.timer = setInterval(imApi.getPositionAndSessionStatus, 3000, objData, (res) => {
            //console.log("你去轮训")
            if(res.code ===1){
                let data = res.data
                if (data.position === -1){
                    clearInterval(state.timer);
                    if (data.sessionStatus === 'chatting') {
                      console.log('还有这')
                      // state.newSession = true
                      // sessionStorage.setItem('newSession',true)
                        router.replace({path: '/imSession', query: {v: visitorMd5Code}})
                    }
                }
                commit('setCurrentPosition', data.position);

            }else if (res.code === 4208) {
                console.error('无法获取到IM会话，或者会话已经过期');
                return
            }
        });
    },


    resetSessionNoReplyTimer ({dispatch,commit, state}, visitorMd5Code) {

      if (!state.autoReplyConfig.sessionTimeoutMsg  || !state.autoReplyConfig.sessionTimeoutFlag) return;
      clearInterval(state.sessionNoReplyTimer)
      let timeout = state.autoReplyConfig.sessionTimeout
      if( localStorage.getItem('sessionTime') && state.autoReplyConfig.sessionTimeout != JSON.parse(localStorage.getItem('sessionTime')).time && visitorMd5Code == JSON.parse(localStorage.getItem('sessionTime')).id){
        timeout = JSON.parse(localStorage.getItem('sessionTime')).time
      }else {
        timeout = state.autoReplyConfig.sessionTimeout
      }


      let timerFunction = () => {
        timeout--
        console.log('会话超时关闭',timeout)
        if(timeout == 60){
          imApi.sendAutoMessage(visitorMd5Code, {
            type: 3,
            toId: state.currentUserId,
            toName: state.userNickNamePool[state.currentUserId],
            // head:state.head,
            content: state.autoReplyConfig.sessionTimeoutMsg
          }, (res) => {
            if(res.code === 1){
              commit('addMessageContentToMessageList', {
                type: Constants.TEXT_TYPE,
                data: state.autoReplyConfig.sessionTimeoutMsg,
                sendFrom: state.currentUserId,
                head:state.head,
                userNickName: state.userNickNamePool[state.currentUserId],
                time : res.timestamp
              })
            }
          })

          function timechange(timestamp){
            var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var  M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ''
              return Y+M+D;
          }
          var obj1={
            "content": state.autoReplyConfig.sessionTimeoutMsg,
            "name": state.userNickNamePool[state.currentUserId]
            };
            console.log('是resetSessionNoReplyTimer的问题吗')
           obj1.id=new Date().getTime();
           obj1.time=timechange(obj1.id);
           dispatch("infortx",obj1)
             console.log('不是resetSessionNoReplyTimer的问题吗')
        }
        if(timeout == 0){
          /*结束会话*/
          // state.endis=false;
          // sessionStorage.setItem("inviteis", false);
          // imApi.getOverSession(visitorMd5Code, body => {
          //   if (body.code === 1) {
          //     if(state.autoReplyConfig.popCsr){
          //       console.log('jinqumei')
          //       commit("setShowSatisfySettingFlag", true);
          //       dispatch("getSatisfySettting", {visitorMd5Code:visitorMd5Code});
          //     }
          //     commit('sendFinishedMsg', visitorMd5Code)
          //     clearInterval(state.userNoReplyTimer)
          //     clearInterval(state.visitorNoReplyTimer)
          //     clearInterval(state.sessionNoReplyTimer)
          //   }
          // })
        }
        state.sessionTime = timeout
        //新存的
        localStorage.setItem('session',timeout)
      }
      state.sessionNoReplyTimer = setInterval(timerFunction,1000)
    },

    resetVisitorNoReplyTimer ({dispatch,commit, state}, visitorMd5Code) {

        if (!state.autoReplyConfig.visitorTimeoutMsg  || !state.autoReplyConfig.visitorTimeoutFlag) return;
        clearInterval(state.visitorNoReplyTimer)
        clearInterval(state.visitorFun)
        let timeout = state.autoReplyConfig.visitorTimeout,
            visitTime = ''
        if( localStorage.getItem('visitTime') && state.autoReplyConfig.visitTime != JSON.parse(localStorage.getItem('visitTime')).time && visitorMd5Code == JSON.parse(localStorage.getItem('visitTime')).id){
            visitTime = JSON.parse(localStorage.getItem('visitTime')).time
        }else {
            visitTime = state.autoReplyConfig.visitorTimeout
        }

        state.visitorFun = setInterval(function () {
          visitTime--
          if(visitTime == 0){
            visitTime = state.autoReplyConfig.visitorTimeout
          }
          state.visitTime = visitTime
          //新存的
          localStorage.setItem('visit',visitTime)
          console.log(state.visitTime,'访客计时')
        },1000)


        let timerFunction = () => {
          imApi.sendAutoMessage(visitorMd5Code, {
                type: 1,
                toId: state.currentUserId,
                toName: state.userNickNamePool[state.currentUserId],
                // head:state.head,
                content: state.autoReplyConfig.visitorTimeoutMsg
            }, (res) => {
              if(res.code === 1){
                commit('addMessageContentToMessageList', {
                  type: Constants.TEXT_TYPE,
                  data: state.autoReplyConfig.visitorTimeoutMsg,
                  sendFrom: state.currentUserId,
                  head:state.head,
                  userNickName: state.userNickNamePool[state.currentUserId],
                  time : res.timestamp
                })
              }
            })


            function timechange(timestamp){
            var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var  M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ''
              return Y+M+D;
              }
            var obj1={
             "content": state.autoReplyConfig.visitorTimeoutMsg,
              "name": state.userNickNamePool[state.currentUserId]
              };
             obj1.id= Number(new Date());
             obj1.time=timechange(obj1.id);
             dispatch("infortx",obj1)
        }

        console.log('访客不回复超时时间: ' + timeout + '秒')
        if (!(timeout > 1)) {
            // MessageBox('提示', '访客回复超时时间小于1秒')
            timeout = 20
        }
        if(localStorage.getItem('visitTime') && visitorMd5Code == JSON.parse(localStorage.getItem('visitTime')).id &&
          state.autoReplyConfig.visitorTimeout != JSON.parse(localStorage.getItem('visitTime')).time &&
          !state.visitTimeYes)
        {
          state.visitTimeYes = true
          state.visitorNoReplyTimer = setInterval(timerFunction, JSON.parse(localStorage.getItem('visitTime')).time * 1000)
          state.visitorNoReplyTimerOut = setTimeout(function () {
            clearInterval(state.visitorNoReplyTimer)
            state.visitorNoReplyTimer = setInterval(timerFunction, timeout * 1000)
          },JSON.parse(localStorage.getItem('visitTime')).time * 1000)
        }else {
          state.visitorNoReplyTimer = setInterval(timerFunction, timeout * 1000)
        }
    },
    resetUserNoReplyTimer ({dispatch,commit, state}, visitorMd5Code) {

        if (!state.autoReplyConfig.userTimeoutMsg || !state.autoReplyConfig.userTimeoutFlag) return;
        if(state.userNoReplyTimer){
          clearInterval(state.userNoReplyTimer)
        }
        clearInterval(state.userFun)

        let timeout = state.autoReplyConfig.userTimeout,
            userTime = ''

        if( localStorage.getItem('userTime') && state.autoReplyConfig.userTimeout != JSON.parse(localStorage.getItem('userTime')).time && visitorMd5Code == JSON.parse(localStorage.getItem('userTime')).id){
            userTime = JSON.parse(localStorage.getItem('userTime')).time
        }else {
            userTime = state.autoReplyConfig.userTimeout
        }

        state.userFun = setInterval(function () {
          userTime--
          if(userTime == 0){
            userTime = state.autoReplyConfig.userTimeout
          }
          state.userTime = userTime
          //新存的
          localStorage.setItem('user',userTime)
          console.log(state.userTime,'客服计时')
        },1000)



        let timerFunction = () => {
        imApi.sendAutoMessage(visitorMd5Code, {
            type: 2,
            toId: state.currentUserId,
            toName: state.userNickNamePool[state.currentUserId],
            // head:state.head,
            content: state.autoReplyConfig.userTimeoutMsg
        }, (res) => {
          if(res.code === 1){
            commit('addMessageContentToMessageList', {
              type: Constants.TEXT_TYPE,
              data: state.autoReplyConfig.userTimeoutMsg,
              sendFrom: state.currentUserId,
              head:state.head,
              userNickName: state.userNickNamePool[state.currentUserId],
              time : res.timestamp
            })
          }
        })


        function timechange(timestamp){
            var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var  M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate()) + ''
              return Y+M+D;
          }
          var obj1={
            "content": state.autoReplyConfig.userTimeoutMsg,
            "name": state.userNickNamePool[state.currentUserId]
            };
             console.log('是resetUserNoReplyTimer的问题吗')
           obj1.id= new Date().getTime();
           obj1.time=timechange(obj1.id);
           dispatch("infortx",obj1)
             console.log('不是resetUserNoReplyTimer的问题吗')

        }

        if (!(timeout > 1)) {
        // Message('提示', '客服回复超时时间小于1秒')
        timeout = 20
        }
        if( localStorage.getItem('userTime') && visitorMd5Code == JSON.parse(localStorage.getItem('userTime')).id &&
          state.autoReplyConfig.userTimeout != JSON.parse(localStorage.getItem('userTime')).time &&
          !state.userTimeYes)
        {
          state.userTimeYes = true
          state.userNoReplyTimer = setInterval(timerFunction, JSON.parse(localStorage.getItem('userTime')).time * 1000)
          state.userNoReplyTimerOut = setTimeout(function () {
            clearInterval(state.userNoReplyTimer)
            state.userNoReplyTimer = setInterval(timerFunction, timeout * 1000)
          },JSON.parse(localStorage.getItem('userTime')).time * 1000)
        }else {
          state.userNoReplyTimer = setInterval(timerFunction, timeout * 1000)
        }
    },
    getLastMessage ({commit,state},obj) {
        let visitorMd5Code = obj.visitorMd5Code;
        let offsetSeq = obj.offsetSeq;
        let sessionId = obj.sessionId;
        if(!offsetSeq) state.messageList = [];
        let router = obj.router;
        return new Promise ((resolve, reject) => {
            imApi.lastMessage(visitorMd5Code,offsetSeq, sessionId,(res) => {
                if(res.code===1){
                    var data = res.data;
                    let imMsgRecords = data.imMsgRecords;

                    state.userNickNamePool[data.currentSessionUserId] = data.currentSessionUserNickName
                    state.currentUserId = Number(data.currentSessionUserId)
                    state.head = data.currentSessionUserHead? (data.currentSessionUserHead.head? data.currentSessionUserHead.head:'/static/assets/service_pic@2x.png'):'/static/assets/service_pic@2x.png'

                    imMsgRecords.forEach((item,index) => {
                        let imMsgRecord = imMsgRecords[index].imMsgRecord;
                        let seq = imMsgRecords[index].seq;
                        let userNickName = imMsgRecords[index].userNickName? imMsgRecords[index].userNickName: state.userNickNamePool[state.currentUserId];
                        let head = imMsgRecord.head? imMsgRecord.head :'/pc/static/assets/service_pic@2x.png'
                        // 初始化 去重容器
                        let sessionId = imMsgRecord.sessionId;
                        let msgId = imMsgRecord.msgId;
                        state.uniqueMsgMap[sessionId+'_'+msgId] = sessionId+'_'+msgId
                        /**
                         * 添加历史记录到messageList
                         */
                        if (imMsgRecord.contents[0].msgType === 'EVENT'){ // 事件流
                          console.log("=============applicationType=" + imMsgRecord.applicationType)
                            if (imMsgRecords[index].toDo === true && imMsgRecord.applicationType === "EVALUATE_NOTIFY") { // 评价
                                    commit('unshiftEventMessage', {
                                      workOrderId: imMsgRecord.contents[0].msgContent.id,
                                      msgId: imMsgRecord.msgId,
                                      content:imMsgRecord.contents[0].msgContent.content,
                                      head:head, seq: seq,
                                      sessionId: imMsgRecord.sessionId})
                            }
                            else if (imMsgRecords[index].toDo === true && imMsgRecord.applicationType === 'WORKORDER_NOTIFY') {
                                    commit('unshiftWorkOrderMessage', {workOrderId: imMsgRecord.contents[0].msgContent.id,
                                                                        msgId: imMsgRecord.msgId,
                                                                        content:imMsgRecord.contents[0].msgContent.content,
                                                                        toDo: imMsgRecords[index].toDo,
                                                                        head:head,
                                                                        seq: seq,
                                                                        sessionId: imMsgRecord.sessionId,
                                                                        time:imMsgRecord.createdAt
                                                                    })
                            }
                             else if (imMsgRecords[index].toDo === null && imMsgRecord.applicationType === 'WORKORDER_COMFIRM') {
                                    commit('unshiftMessageContentToMessageList', {
                                                                        workOrderId: imMsgRecord.contents[0].msgContent.id,
                                                                        msgId: imMsgRecord.msgId,
                                                                        data:'您已提交了工单: '+imMsgRecord.contents[0].msgContent.content.split(" ")[1],
                                                                        toDo: imMsgRecords[index].toDo,
                                                                        type: Constants.TEXT_TYPE,
                                                                        userNickName: userNickName,
                                                                        seq: seq,
                                                                        head:head,
                                                                        sessionId: imMsgRecord.sessionId,
                                                                        time:imMsgRecord.createdAt
                                                                    })

                             }
                              else if (imMsgRecords[index].toDo === null && imMsgRecord.applicationType === 'SERVICE_NOTIFY'/*会话转接or介入*/) {
                                console.log(data.imMsgBody,"会话转接or介入");
                                commit('unshiftMessageContentToMessageList',{
                                    data:imMsgRecord.contents[0].msgContent.content,
                                    // type:imMsgBody.content[0].msgType,
                                    type:'TEXT',
                                    seq: imMsgRecord.seq,
                                    sessionId: imMsgRecord.sessionId,
                                    //userNickName: data.imMsgBody.content[0].msgContent.userNickName,
                                    // sendFrom: Number(imMsgBody.content[0].msgContent.userNickName),
                                    // userNickName: state.userNickNamePool[Number(imMsgBody.content[0].msgContent.userId)],
                                    sendFrom: imMsgRecord.sendFrom,
                                    userNickName: userNickName,
                                    head:head,
                                    time:imMsgRecord.createdAt
                                })
                            }
                        }else{
                          console.log("==============msgType不是EVENT===========")
                            commit('unshiftMessageContentToMessageList', {
                                type: imMsgRecord.contents[0].msgType,
                                data: imMsgRecord.contents[0].msgType === 'TEXT' || imMsgRecord.contents[0].msgType === 'EVENT' ? imMsgRecord.contents[0].msgContent.content : imMsgRecord.contents[0].msgContent.url,
                                imgSrc: imMsgRecord.contents[0].msgContent.url,
                                sessionId: imMsgRecord.sessionId,
                                seq: seq,
                                sendFrom: imMsgRecord.sendFrom,
                                userNickName: userNickName,
                                head:head,
                                revoked:imMsgRecord.revoked || false,
                                time: imMsgRecord.revoked? imMsgRecord.revokeTime : imMsgRecord.createdAt
                            })
                        }
                    })
                }
                resolve()
            })
        })
    },
    cancelWait({commit,state},obj){
        let visitorMd5Code = obj.visitorMd5Code;
        return new Promise((resolve,reject) => {
            imApi.cancelWait(visitorMd5Code,res =>{
                if(res.code === 1){

                }
                resolve();
            })
        })
    },
    workOrderSubmittied ({dispatch, commit, state}, obj){
        let visitorMd5Code = obj.visitorMd5Code;
        let workOrderId = obj.workOrderId
        let orderName = obj.orderName
        imApi.workOrderSubmittied(visitorMd5Code, workOrderId, orderName, body => {
            if(body.code ===1 ){
                state.messageList.forEach( function(element, index) {
                    if(element.msgId==obj.msgId){
                        element.type="TEXT";
                        element.data="您已提交了工单:"+obj.orderName;
                    }
                });

              localStorage.removeItem('userTime')
              dispatch('resetUserNoReplyTimer', visitorMd5Code) // 重置 访客无响应 定时器


              clearInterval(state.visitorNoReplyTimer)
              clearTimeout(state.visitorNoReplyTimerOut)
              clearInterval(state.visitorFun)

              localStorage.removeItem('sessionTime')
              dispatch('resetSessionNoReplyTimer', visitorMd5Code) // 重置 访客无响应 定时器
            }
        })
    },

    getHttp({dispatch, commit, state}, obj){
      let visitorMd5Code = obj.visitorMd5Code
      imApi.getHttp(visitorMd5Code, body => {
        if (body.code === 1) {
          let data = body.data.imagePrefix
          commit('setHttp', data)
        }
      })
    },

    getAutoReply ({dispatch, commit, state}, obj) {
         let visitorMd5Code = obj.visitorMd5Code;

        imApi.getSessionStatus(visitorMd5Code, body => {
            console.log('-----------------获取自动消息--------')
            console.log(body)
          if (body.code === 1) {
            let status = body.data.status
            if(status=='ended'){
                sessionStorage.setItem("inviteis", false);
                state.endis=false;
            }
            console.log('重连之后获取到会话状态: ' + status)
            if (status !== 'chatting') {
              clearInterval(state.userNoReplyTimer)
              clearInterval(state.userFun)
              clearInterval(state.visitorNoReplyTimer)
              clearInterval(state.visitorFun)
              clearInterval(state.sessionNoReplyTimer)
            }else {
              imApi.getAutoReply(visitorMd5Code, body => {
                if (body.code === 1) {
                  let data = body.data
                  commit('setAutoReplyConfig', data)
                  console.log('是否发送欢迎语：'+sessionStorage.getItem('newSession'));
                  if (sessionStorage.getItem('newSession') == 'true') { // 每一个会话只有一个欢迎语
                    state.newSession = false
                    sessionStorage.setItem('newSession',false)
                    commit('sendWelComeMessage', visitorMd5Code)

                    if (data.userTimeoutFlag === true) {
                      localStorage.removeItem('userTime')
                      dispatch('resetUserNoReplyTimer', visitorMd5Code);
                    }
                    if (data.visitorTimeoutFlag === true) {
                      localStorage.removeItem('visitTime')
                      dispatch('resetVisitorNoReplyTimer', visitorMd5Code)
                    }
                    if (data.sessionTimeoutFlag === true) {
                      localStorage.removeItem('sessionTime')
                      dispatch('resetSessionNoReplyTimer', visitorMd5Code)
                    }

                  }else {

                    if(data.sessionTimeoutFlag === true){
                      dispatch('resetSessionNoReplyTimer', visitorMd5Code)
                    }


                    for(var i = state.messageList.length - 1;i>=0;i-- ){
                      if(state.messageList[i].sendFrom == visitorMd5Code){

                        if(data.userTimeoutFlag === true){

                          dispatch('resetUserNoReplyTimer', visitorMd5Code)
                        }

                        return
                      }else if(state.messageList[i].sendFrom != visitorMd5Code && state.messageList[i].sendFrom != '0'){

                        if(data.visitorTimeoutFlag === true){
                          dispatch('resetVisitorNoReplyTimer', visitorMd5Code)
                        }
                        return
                      }else if(state.messageList[i].sendFrom == '0' && state.messageList.every(function (item,index) {
                          return item.sendFrom == '0'
                        })){

                          dispatch('resetUserNoReplyTimer', visitorMd5Code)
                          dispatch('resetVisitorNoReplyTimer', visitorMd5Code)

                        return
                      }
                    }
                  }
                }
              })
            }
          }
        })
    },

    sendMessage ({dispatch, commit, state},obj) {
        let content = obj.content
        let contentType = obj.contentType
        let visitorMd5Code = obj.visitorMd5Code
        var vm=this;

      localStorage.removeItem('userTime')
        dispatch('resetUserNoReplyTimer', visitorMd5Code) // 重置 访客无响应 定时器
        if(state.visitorNoReplyTimer){
         clearInterval(state.visitorNoReplyTimer)
        }
        clearTimeout(state.visitorNoReplyTimerOut)
        clearInterval(state.visitorFun)

      localStorage.removeItem('sessionTime')
        dispatch('resetSessionNoReplyTimer', visitorMd5Code) // 重置 访客无响应 定时器

        if(content && content.trim()) {
            imApi.sendMessage(visitorMd5Code,{content: content,contentType: contentType} ,res => {
                if(res.code ===1){
                    console.log(res.data,"发送消息回执");
                    let messageItem = {
                        data: content,
                        type: contentType,
                        sendFrom: visitorMd5Code,
                        time: res.data.currentTime,
                        signId: obj.signId,
                        status: 'success'
                        //seq: res.data.seq,
                        //sessionId: res.data.sessionId
                    }
                    if(res.data.connected==false){
                        location.reload();
                    }
                    if ((contentType == Constants.IMAGE_TYPE || contentType == Constants.VIDEO_TYPE) && obj.signId) {
                      commit('cptMsg', messageItem)
                    } else {
                      commit('addMessageContentToMessageList', messageItem)
                    }
                    // commit('addMessageContentToMessageList', messageItem);
                    setTimeout(function () {
                        var chat = document.getElementsByClassName('chat')[0];
                        chat.scrollTop = chat.scrollHeight;
                    }, 100);
                }
                 if(res.code ===4208){
                    clearInterval(state.userNoReplyTimer)
                    clearInterval(state.userFun)
                    clearInterval(state.visitorNoReplyTimer)
                    clearInterval(state.visitorFun)
                    clearInterval(state.sessionNoReplyTimer);
                    state.endis=false;
                    sessionStorage.setItem("inviteis", false);
                    Message({
                      message: '会话已过期，请重新排队',
                      type: 'warning'
                    });
                }

            })
        }
    },
    getSatisfySettting ({dispath, commit, state}, obj) {
        let visitorMd5Code = obj.visitorMd5Code;
        imApi.satisfySetting(visitorMd5Code, (res) => {

            if(res.code=== 1) {
            console.log("hdsjhsjhsjhjshsjhj")
            console.log(res.data.mode)
            console.log(res)
                if(res.data.mode ===1) {
                     commit('setSatisfySetting', res.data.mode);
                }else if (res.data.mode ===2) {

                     commit('setSatisfySetting', res.data.mode);
                }
            }

        })
    },
    evaluate ({dispatch, commit, state}, obj){
        let visitorMd5Code = obj.visitorMd5Code;
        imApi.evaluate(obj, (res) => {
            if(res.code===1){
                Message({showClose: true, message: '评价成功',type: 'success'})
                commit("setShowSatisfySettingFlag", false);

              imApi.getSessionStatus(visitorMd5Code, body => {
                if (body.code === 1) {
                  let status = body.data.status
                  if (status == 'chatting') {
                    localStorage.removeItem('userTime')
                    dispatch('resetUserNoReplyTimer', visitorMd5Code) // 重置 访客无响应 定时器
                    if(state.visitorNoReplyTimer){
                      clearInterval(state.visitorNoReplyTimer)
                    }
                    clearTimeout(state.visitorNoReplyTimerOut)
                    clearInterval(state.visitorFun)

                    localStorage.removeItem('sessionTime')
                    dispatch('resetSessionNoReplyTimer', visitorMd5Code) // 重置 访客无响应 定时器

                  }else {
                    if(state.visitorNoReplyTimer){
                      clearInterval(state.visitorNoReplyTimer)
                    }
                    clearTimeout(state.visitorNoReplyTimerOut)
                    clearInterval(state.visitorFun)
                  }
                }
              })




            }else if(res.code = 4214) {
                Message({showClose: true, message: '您已经评价过了！', type: 'warning'})
            }else if(res.code = 4029) {
                Message({showClose: true, message: '请对我们的服务做出评价哟！', type: 'warning'})
            }else if(res.code = 4030) {
                Message({showClose: true, message: '需要评价处理时长', type: 'warning'})
            }else if(res.code = 4031) {
                Message({showClose: true, message: '需要评价处理结果', type: 'warning'})
            }else if(res.code = 4221) {
                Message({showClose: true, message: '会话不存在', type: 'warning'})
            }else{
                Message({showClose: true, message: '评价失败', type: 'warning'})
            }
        })
    },
    sendTransientMessage ({dispath, commit, state}, obj) {  // 实时消息
        let visitorMd5Code = obj.visitorMd5Code;
        let data = {
            visitorMd5Code,
            form:{
                content: obj.content,
                contentType: obj.contentType
            }
        }
        imApi.sendTransientMessage(data, res => {

        })
    },
    uploadVideo ({dispatch, commit}, obj) {
      let visitorMd5Code = obj.visitorMd5Code
      let file = obj.file
      console.log('file999：', file)
      if (!file) return
      if (file.size / 1024 > 512000) {
        Message({
          type:'warning',
          message:"最大只允许发送500M视频"
        })
        return
      }
      // TODO 文件类型也得判断
      if (!file.type.match(videoRex)) {
        Message({
          type:'warning',
          message:"目前只支持mp4/avi/wmv/mov格式的视频"
        })
        return
      }
      const videoUrl = getObjectURL(new Blob([file]))
      getVideoCover(file, videoUrl, 1, url => {
        const messageItem = {
          data: url,
          type: Constants.VIDEO_TYPE,
          sendFrom: visitorMd5Code,
          seq: '',
          sessionId: '',
          signId: obj.signId,
          status: 'loading',
          time: obj.ctm
        }
        commit('addMessageContentToMessageList', messageItem)
        // 处理成功会执行
        let formData = new FormData()
        formData.append('file', file)
        imApi.sendImgMsg(visitorMd5Code, formData, body => {
          if (body.code === 1) {
            let videoSrc = body.data
            console.log('视频地址: ' + videoSrc)
            if (!videoSrc) return
            console.log('setTimeout')
            dispatch({
              type: 'sendMessage',
              contentType: Constants.VIDEO_TYPE,
              content: videoSrc,
              visitorMd5Code: visitorMd5Code,
              signId: obj.signId
            })
            state.uniqueMsgMap[body.data.sessionId+'_'+body.data.msgId] = true;
          } else if (body.code === 4012) {
            MessageBox('提示', '目前只支持mp4/avi/wmv/mov格式的视频')
            return
          } else if (body.code === 4013) {
            MessageBox('提示', '最大只允许发送5M视频')
            return
          }
        })
      })
    },
    sendImgMsg ({dispatch, commit, state}, obj) {
       let visitorMd5Code = obj.visitorMd5Code;
       console.log(obj.file,"file")
       let file = obj.file;
       if(!file) return
       console.log(file.size, file.type,"file.size, file.type")
       if (file.type.match(videoRex)) {
        dispatch('uploadVideo', obj)
        obj.callback && obj.callback()
        return
       }
       if (file.size / 1024 > (1024 * 9)) {
            Message({
                type:'warning',
                message:"最大只允许发送9M图片"
            })
            return
        }
        // 判断文件类型
        if(!file.type.match(imageRex)) {
             Message({
                type:'warning',
                message:"目前只支持jpg/png/bmp/gif格式的图片"
            })
            return
        }
        const messageItem = {
          data: getObjectURL(file),
          type: Constants.IMAGE_TYPE,
          sendFrom: visitorMd5Code,
          seq: '',
          sessionId: '',
          signId: obj.signId,
          status: 'loading',
          time: obj.ctm
        }
        commit('addMessageContentToMessageList', messageItem)
        // let formData = new FormData();
        // formData.append('file',file);
        lrz(file)
          .then(function (rst) {
            imApi.sendImgMsg (visitorMd5Code, rst.formData, res => {
                // 添加一个回调函数用来清空file的input的值 // 清空image选择框的值
                obj.callback && obj.callback()
                if(res.code ===1 ) {
                    let imgSrc = res.data;
                    if (!imgSrc) return
                    dispatch({
                        type: 'sendMessage',
                        contentType: Constants.IMAGE_TYPE,
                        content: imgSrc,
                        visitorMd5Code: visitorMd5Code,
                        signId: obj.signId
                    })
                }else if (body.code === 4012) {
                    Message({
                        type:'warning',
                        message:"目前只支持jpg/png/bmp/gif格式的图片"
                    } )
                    return
                } else if (body.code === 4013) {
                    Message({
                        type:'warning',
                        message:"最大只允许发送9M图片"
                    } )
                    return
                }
            })
          })
    },

    initUserPool ({dispatch, commit, state}, obj) {
      let visitorMd5Code = obj.visitorMd5Code
      imApi.getUserNickNames(visitorMd5Code, function (body) {
        if (body.code === 1) {
          commit('initUserPool', body.data)
        }
      })
    }
}
const mutations = {
  cptMsg(state, obj){
    state.messageList.forEach(item=> {
      if (item.signId == obj.signId) {
        item.data = obj.data
        item.status = 'success'
      }
    })
  },
    initUserPool (state, data) {
      state.userNickNamePool = data
    },

    setEntranceId (state, entranceId) {

        state.entranceId = Number(entranceId)
    },
    setEntranceList (state, entranceList) {
        state.entranceList = entranceList
    },
    setShowSatisfySettingFlag (state, showSatisfySettingFlag) {
        state.showSatisfySettingFlag = showSatisfySettingFlag
    },
    setCurrentPosition (state, currentPosition) {
        console.log('setCurrentPosition')
        console.log(currentPosition)
        state.currentPosition = currentPosition
    },
    setSatisfySetting (state, satisfyMode) {
         console.log('satisfyMode')
        console.log(satisfyMode)
        state.satisfyMode = satisfyMode
    },
    setAutoReplyConfig (state, autoReplyConfig) {
        state.autoReplyConfig = autoReplyConfig
    },
    setHttp (state, autoReplyConfig) {
        state.imHttp = autoReplyConfig
    },
    addMessageContentToMessageList (state, messageContent) {
         if(messageContent.type === Constants.TEXT_TYPE){
            messageContent.data = processLinkMessage(messageContent.data,messageContent.sendFrom)
         }
         console.log(messageContent,"messagecontent")
         state.messageList.push(messageContent);

        setTimeout(function () {
                var chat = document.getElementsByClassName('chat')[0]; //  为啥这么处理
                if(chat){
                    chat.scrollTop = chat.scrollHeight;
                }

        }, 100);
    },
    revokeMessageList(state, data) {
      const { msgId, createdTime } = data
      state.messageList.forEach((item)=>{
        if (item.msgId == msgId) {
          item.revoked = true
          item.time = createdTime
        }
      })
    },
    unshiftMessageContentToMessageList (state, messageContent) {
        if(messageContent.type === Constants.TEXT_TYPE) {
            messageContent.data = processLinkMessage(messageContent.data,messageContent.sendFrom);
        }
        state.messageList.unshift(messageContent)
        setTimeout(function () {
            var chat = document.getElementsByClassName('chat')[0];
            //chat.scrollTop = chat.scrollHeight;
            chat.scrollTop = chat.scrollTop + 40;

        }, 100);
    },
    sendWelComeMessage (state, visitorMd5Code) {
      if(sessionStorage.getItem('inviteis') == 'true'){
        console.log('----------发送邀请语-------')
        imApi.getinvitations(visitorMd5Code,function(res){
            var invitations = res.data.invitations
            imApi.sendAutoMessage(visitorMd5Code, {
                type: 4,
                content: invitations,
                toId: state.currentUserId,
                toName: state.userNickNamePool[state.currentUserId],
              // head:state.head
            }, (res) => {
              if(res.code === 1){
                state.messageList.push({
                  type: Constants.TEXT_TYPE,
                  data: invitations,
                  sendFrom: state.currentUserId,
                  userNickName: state.userNickNamePool[state.currentUserId],
                  head:state.head,
                  time:res.timestamp
                })
              }
            })

            setTimeout(function () {
            var chat = document.getElementsByClassName('chat')[0];
            chat.scrollTop = chat.scrollHeight;
            }, 100);
        })
      }else{
        if (state.autoReplyConfig.welcomeMsg && state.autoReplyConfig.welcomeMsg.length > 0)
            imApi.sendAutoMessage(visitorMd5Code, {
                type: 4,
                content: state.autoReplyConfig.welcomeMsg,
                toId: state.currentUserId,
                toName: state.userNickNamePool[state.currentUserId],
              // head:state.head
            }, (res) => {
              if(res.code === 1){
                state.messageList.push({
                  type: Constants.TEXT_TYPE,
                  data: state.autoReplyConfig.welcomeMsg,
                  sendFrom: state.currentUserId,
                  userNickName: state.userNickNamePool[state.currentUserId],
                  head:state.head,
                  time:res.timestamp
                })
              }
            })

            setTimeout(function () {
            var chat = document.getElementsByClassName('chat')[0];
            chat.scrollTop = chat.scrollHeight;
            }, 100);
      }

    },
    sendWorkOrderMessage (state, obj) {
        console.log('sendWorkOrderMessage, 工单ID: ' + obj.workOrderId)

        if(obj.workOrderId){
            state.messageList.push({
                type: Constants.WORK_ORDER_TYPE,
                data: obj.workOrderId,
                sendFrom: state.currentUserId,
                userNickName: state.userNickNamePool[state.currentUserId],
                msgId: obj.msgId,
                head:obj.head,
                time:obj.time
            })
        }
        // else if(obj.data){
        //     state.messageList.push({
        //         type: Constants.TEXT_TYPE,
        //         data: obj.workOrderId ? obj.workOrderId : obj.data,
        //         sendFrom: state.currentUserId,
        //         userNickName: state.userNickNamePool[state.currentUserId],
        //         msgId: obj.msgId
        //     })
        // }

        setTimeout(function () {
            var chat = document.getElementsByClassName('chat')[0];
            chat.scrollTop = chat.scrollHeight;
        }, 100);
    },
    unshiftWorkOrderMessage (state, obj) {
        state.messageList.unshift({
            type: Constants.WORK_ORDER_TYPE,
            data: Number(obj.workOrderId),
            sendFrom: state.currentUserId,
            userNickName: state.userNickNamePool[state.currentUserId],
            msgId: obj.msgId,
            head:obj.head,
            seq:obj.seq,
            sessionId:obj.sessionId,
            time:obj.time
        })
        setTimeout(function () {
            var chat = document.getElementsByClassName('chat')[0];
            //chat.scrollTop = chat.scrollHeight;
            chat.scrollTop = chat.scrollTop + 40;
        }, 100);
    },
    unshiftEventMessage (state, obj) {
        state.messageList.unshift({
            type: Constants.EVENT_TYPE,
            data: obj.workOrderId ? obj.workOrderId :obj.content,
            sendFrom: state.currentUserId,
            userNickName: state.userNickNamePool[state.currentUserId],
            msgId: obj.msgId,
            head:state.head,
            seq:obj.seq,
            sessionId:obj.sessionId
        })
        setTimeout(function () {
            var chat = document.getElementsByClassName('chat')[0];
            chat.scrollTop = chat.scrollHeight;
        }, 100);
    },
    sendFinishedMsg (state, visitorMd5Code) {
        if (state.autoReplyConfig.finishedMsg && state.autoReplyConfig.finishedMsg.length > 0) {
          imApi.sendAutoMessage(visitorMd5Code, {
                type: 4,
                toId: state.currentUserId,
                toName: state.userNickNamePool[state.currentUserId],
                content: state.autoReplyConfig.finishedMsg,
              // head:state.head,
            }, (res) => {
              if(res.code === 1){
                state.messageList.push({
                  type: 'TEXT',
                  data: state.autoReplyConfig.finishedMsg,
                  sendFrom: state.currentUserId,
                  userNickName: state.userNickNamePool[state.currentUserId],
                  head:state.head,
                  time:res.timestamp
                })
              }
            })
            setTimeout(function () {
                var chat = document.getElementsByClassName('chat')[0];
                chat.scrollTop = chat.scrollHeight;
            }, 100);
        }

    },

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/im.js